export default __webpack_public_path__ + "static/media/img-digital-cash-horizontal.20d60610.png";